(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputInline', cpInputInline);

    cpInputInline.$inject = [];

    function cpInputInline() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-inline/input-inline.html',
            scope: {
                title: '@',
                object: '=',
                isRequired: '=?',
                isDisabled: '=?',
                onChange: '&?',
                inputFields: '=?'
            },
            link: function(scope, element, attrs, controller) {}
        };
    }
})();

